import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=5bbb2c77&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=ts&"
export * from "./RoleList.vue?vue&type=script&lang=ts&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=5bbb2c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb2c77",
  null
  
)

/* custom blocks */
import block0 from "./RoleList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports